'use stritc'
import axios from '../utils/axios'
import _ from 'lodash'

export default {
  async getWokflowsByJobId(jobId, env = 'dev', ) {
    try {
      if (!jobId) {
        throw new Error('Invalid job id value to get workflows')
      }
      const axiosInstance = axios.getInstance(env, {}, true)
      if (!axiosInstance) {
        throw new Error('Ivalida axios instace gotten')
      }
      let response = await axiosInstance.get(`/job-details?id=${jobId}`)
      console.log(response)
      let data =  (!response || !response.data.workflows) ? [] : response.data.workflows
      return data
    } catch (error) {
      console.error(error)
    }
  }
}


// WEBPACK FOOTER //
// ./src/requests/workflows.js